import { render, staticRenderFns } from "./CSFollowRequests.vue?vue&type=template&id=35d5bd4f&"
import script from "./CSFollowRequests.vue?vue&type=script&lang=js&"
export * from "./CSFollowRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports